<template>
  <div class="auto-renewal-cancel">
    <Header :noNav="false"></Header>
    <Loader v-if='isLoading' />
    <b-container>
      <b-row>
        <b-col sm="12">
          <div class="auto-renewal-cancel__row">
            <h1>{{ title }}</h1>
            <cpSelect
              id="reasons"
              class='auto-renewal-cancel__select'
              name="reasons"
              type="select"
              validations="required"
              label="Motivo do cancelamento"
              :options="listReasons"
              :value="selectedReason"
              @change="setReason"
            />
            <b-button
              class='auto-renewal-cancel__btn'
              variant='purple'
              size='lg'
              pill
              :disabled="!selectedReason"
              @click='confirmRenewal()'
            >
              Confirmar não renovação
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Header from '../Header/Header'
import Loader from '@/components/Loader'

import cpSelect from '../ui/Select.vue'
import { getReasons, patchAutoRenewal } from '@/api/services'

export default {
  name: 'AutoRenewalCancel',
  components: {
    Header,
    Loader,
    cpSelect
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    policyUuid: {
      type: String,
      default: ''
    },
    clientName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      listReasons: [],
      selectedReason: '',
      loading: false
    }
  },
  async beforeMount () {
    this.isLoading = true

    if (!this.policyUuid) {
      this.$router.push({
        name: 'AutoRenewalManagement'
      })
    }

    await getReasons()
      .then((response) => {
        this.listReasons = response.data
        this.isLoading = false
      })
  },
  methods: {
    setReason (reason) {
      this.selectedReason = reason
    },
    async confirmRenewal () {
    this.isLoading = true

    await patchAutoRenewal({
        policyUuid: this.policyUuid,
        autoRenewal: false,
        reason: this.selectedReason
      })
      .then(() => {
        this.$router.push({
          name: 'AutoRenewalConfirmation',
          params: {
            icon: 'success',
            title: `${this.clientName}, sua renovação foi cancelada!`
          }
        })
      })
      .catch((error) => {
        const { message } = error.response && error.response.data

        this.$router.push({
          name: 'AutoRenewalConfirmation',
          params: {
            icon: 'alert',
            title: message || 'Alteração não permitida: comunicação de renovação já foi respondida pelo cliente.'
          }
        })
      })
    }
  }
}
</script>
<style lang="scss">
$breakpoint-mobile: 480px;

.auto-renewal-cancel {
  background-color: #f5f7fa;
  min-height: 100%;

  &__row {
    text-align: center;
    width: 100%;
    margin-top: 48px;
    padding: 0 8px;

    h1 {
      color: #444444;
      font: bold 32px Oscine;
      margin: 12px auto 24px auto;

      @media only screen and (max-width: $breakpoint-mobile) {
        font-size: 24px;
      }
    }

    p {
      font-family: Rubik;
      color: #595959;
      font-size: 16px;
      margin: 0 auto !important;
      max-width: 568px;
    }
  }

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 100%;
    display: inline-block;
    background: url(~@/assets/svg/icone-sucesso.svg) no-repeat center;
  }

  &__select {
    margin: 0 auto 30px auto;
    max-width: 500px;
  }
}
</style>
